import { defineFcm } from '../shared/factory';

export const FCM_SUPPORTER_SHARE_VISUALS = defineFcm('supporter_share_visuals')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-vaquita',
		scope: 'corgi-front-end',
		context: 'Supporter share visuals',
		description: 'Feature flag that enables the share visuals for supporters on the petition page',
		import: false,
		deprecated: 'Only consumer was supporter_share_visuals_experiment (CHANGE-97554) — safe to delete after 2026-09-14',
	});
